export const handleConversion = (data) => {
    if (data.robotPositioning) {
        return data
    }
    if (data.length) {
        const savedData = data.map((point) => {
            point = point = { ...point, rotation: 450 - point.rotation }
            if (point.rotation > 360) point = { ...point, rotation: point.rotation - 360 }
            return point
        })
        return savedData
    }
    data.rotation = 450 - data.rotation
    if (data.rotation > 360) data.rotation = data.rotation - 360
    return data
}

export const handleWheel = (e, isScrollingDown, sizes, setSize) => {
    if (e.evt.ctrlKey || e.evt.metaKey) {
        e.evt.preventDefault()
        const scaleBy = 1.05
        const stage = e.currentTarget
        const oldScale = stage.scaleX()
        const mousePointTo = {
            x: stage.getPointerPosition().x / oldScale - stage.x() / oldScale,
            y: stage.getPointerPosition().y / oldScale - stage.y() / oldScale,
        }
        const invertedScaleBy = isScrollingDown ? 1 / scaleBy : scaleBy
        const newScale = oldScale * invertedScaleBy
        const stageX = -(mousePointTo.x - stage.getPointerPosition().x / newScale) * newScale
        const stageY = -(mousePointTo.y - stage.getPointerPosition().y / newScale) * newScale

        if (sizes && setSize) {
            setSize({
                ...sizes,
                y: stageY,
                x: stageX,
                scale: newScale,
                width: stage.width(),
                height: stage.height(),
            })
        }

        stage.position({
            x: stageX,
            y: stageY,
        })
        stage.scale({ x: newScale, y: newScale })
        stage.batchDraw()
    }
}

export const handleZoomBtns = (stageRef, zoomIn, sizes, setSize) => {
    const scaleBy = 1.05
    const stage = stageRef
    const oldScale = stage.scaleX()

    const newScaleX = zoomIn ? oldScale * scaleBy : oldScale / scaleBy
    const newScaleY = zoomIn ? oldScale * scaleBy : oldScale / scaleBy

    const mousePointTo = {
        x: window.innerWidth / 2 / oldScale - stage.x() / oldScale,
        y: window.innerHeight / 2 / oldScale - stage.y() / oldScale,
    }

    const stageX = -(mousePointTo.x - window.innerWidth / 2 / newScaleX) * newScaleX
    const stageY = -(mousePointTo.y - window.innerHeight / 2 / newScaleY) * newScaleY

    if (sizes && setSize) {
        setSize({
            ...sizes,
            y: stageY,
            x: stageX,
            scale: newScaleX,
            width: stage.width(),
            height: stage.height(),
        })
    }

    stage.position({
        x: stageX,
        y: stageY,
    })
    stage.scale({ x: newScaleX, y: newScaleY })
    stage.batchDraw()
}

export const toBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = (error) => reject(error)
    })
}

export const compressImage = (file, maxWidth = 800) => {
    return new Promise((resolve) => {
        const img = new Image()
        const reader = new FileReader()

        reader.onload = (e) => {
            img.src = e.target.result
        }

        img.onload = () => {
            const canvas = document.createElement('canvas')
            const scale = maxWidth / img.width
            canvas.width = maxWidth
            canvas.height = img.height * scale

            const ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height)

            // Quality can be adjusted here (0.7 = 70% quality)
            const compressedBase64 = canvas.toDataURL('image/jpeg', 0.7)
            resolve(compressedBase64)
        }

        reader.readAsDataURL(file)
    })
}

export const getShortFileName = (fullName, maxLength = 20) => {
    if (!fullName) return ''

    const parts = fullName.split('.')
    const ext = parts.pop() // Get file extension
    const nameWithoutExt = parts.join('.')

    // Split by space, dash, underscore to find last word
    const words = nameWithoutExt.split(/[\s_-]+/)
    const lastWord = words[words.length - 1]

    const display = `...${lastWord}.${ext}`

    return display.length > maxLength ? display.slice(-maxLength) : display
}
